import React from 'react';
import { TabButtonsGroup, TabHeader, TabButton } from './styles';

const Tab = ({ activeTab, setActiveTab, onMouseDown, onTouchStart }) => {
    return (
        <TabHeader onMouseDown={onMouseDown} onTouchStart={onTouchStart}>
            <TabButtonsGroup>
                <TabButton
                    className={activeTab === 'commission' ? 'active' : ''}
                    onClick={() => setActiveTab('commission')}
                    onMouseDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                    aria-label="중개수수료 계산기 탭"
                    aria-selected={activeTab === 'commission'}
                >
                    중개수수료
                </TabButton>
                <TabButton
                    className={activeTab === 'area' ? 'active' : ''}
                    onClick={() => setActiveTab('area')}
                    onMouseDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                    aria-label="평형계산기 탭"
                    aria-selected={activeTab === 'area'}
                >
                    평형계산기
                </TabButton>
                <TabButton
                    className={activeTab === 'monthlyRent' ? 'active' : ''}
                    onClick={() => setActiveTab('monthlyRent')}
                    onMouseDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                    aria-label="월세계산기 탭"
                    aria-selected={activeTab === 'monthlyRent'}
                >
                    월세계산기
                </TabButton>
            </TabButtonsGroup>
        </TabHeader>
    );
};

export default Tab;
